const limitCountdownItem = document.getElementsByClassName('js-limitCountdown')[0]
if (limitCountdownItem) {
  const accessTime = new Date()
  const limitCountdownView = document.getElementsByClassName('js-limitCountdown-time')[0]
  const countDown = setInterval(() => {
    const time = limitCountdownTime(accessTime)
    if (time) {
      limitCountdownView.innerHTML = time
    } else {
      limitCountdownItem.innerHTML = 'ページをリロードすると視聴できます。'
      clearInterval(countDown)
    }
  }, 1000)
}

function limitCountdownTime(accessTime) {
  const now = new Date()
  const limitTime = new Date()
  limitTime.setDate(accessTime.getDate() + 1)
  limitTime.setHours(0)
  limitTime.setMinutes(0)
  limitTime.setSeconds(0)

  const diff = (limitTime.getTime() - now.getTime()) / 1000 // 秒数差を取得

  if (diff <= 0) {
    return false
  }
  // 各時間を計算
  // const day = Math.floor(diff / (24 * 60 * 60));
  let hour = Math.floor(diff / (60 * 60)) % 24
  // hour = ("0" + hour).slice(-2) // 二桁整形
  let minute = Math.floor(diff / 60) % 60
  minute = ('0' + minute).slice(-2) // 二桁整形
  let second = Math.floor(diff) % 60
  second = ('0' + second).slice(-2) // 二桁整形

  // 出力
  return hour + ':' + minute + ':' + second
}
